// extracted by mini-css-extract-plugin
export default {"wrapper":"ComingSoonPage_wrapper__4Nv8y","title":"ComingSoonPage_title__wpzxb","description":"ComingSoonPage_description__L-dua"};